import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
export function Layout() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
  }, [pathname]);
  return <Box w="100%" minH="100vh" bg="white" display="flex" flexDirection="column" data-id="element-103" data-mp="uz2tmaas8v15">
      <Navbar data-id="element-104" data-mp="79ic7vua25tz" />
      <Box as="main" id="main" flex="1" data-id="element-105" data-mp="7904a1y96368">
        <Outlet data-id="element-106" data-mp="29vy7k6mklk4" />
      </Box>
      <Footer data-id="element-107" data-mp="2aovlujp1ypl" />
    </Box>;
}